import { Link } from 'react-router-dom';
import { videoCategories } from '@/mocks/videos';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-play-circle-fill text-xl text-white"></i>
              </div>
              <span className="text-xl font-bold font-heading">蘑菇视频</span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              海量高清视频在线免费观看平台，汇聚影视、综艺、动漫、纪录片等优质内容，随时随地畅享精彩视听体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">
              <a href="#video-categories" className="hover:text-primary-400 transition-colors">视频分类</a>
            </h4>
            <ul className="space-y-2.5">
              {videoCategories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">
              <a href="#quick-links" className="hover:text-primary-400 transition-colors">快速链接</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/category/dianying" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">
                  热门电影
                </Link>
              </li>
              <li>
                <Link to="/category/duanshipin" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">
                  精彩短视频
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">联系我们</h4>
            <ul className="space-y-2.5 text-sm text-foreground-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base"></i>
                <span>contact@mogu-video.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-base"></i>
                <span>400-888-9999</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-base"></i>
                <span>北京市朝阳区望京科技园</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-700/30 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2026 蘑菇视频 MoguVideo.com 版权所有 | 京ICP备2026080001号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors" rel="nofollow" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors" rel="nofollow" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors" rel="nofollow" aria-label="B站">
              <i className="ri-bilibili-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}